var _path, _path2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWorkspace(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 0H0V24H24V0Z",
    fill: "url(#paint0_linear_21507_192393)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.7 20.4H12.3V18.3H11.7V20.4ZM11.7 5.7H12.3V3.6477H11.7V5.7ZM17.7 12.3H20.4V11.7H17.7V12.3ZM3.6 12.3H6.3V11.7H3.6V12.3ZM4.2 10.8H3.6V3.9C3.6 3.7344 3.7341 3.6 3.9 3.6H10.8V4.2H4.2V10.8ZM20.4 3.9V10.8H19.8V4.2H13.2V3.6H20.1C20.2659 3.6 20.4 3.7344 20.4 3.9ZM19.8 13.2H20.4V20.1C20.4 20.2656 20.2659 20.4 20.1 20.4H13.2V19.8H19.8V13.2ZM4.2 19.8H10.8V20.4H3.9C3.7341 20.4 3.6 20.2656 3.6 20.1V13.2H4.2V19.8ZM12.3 16.5864V12.1749L16.2 9.9648V14.376L12.3 16.5864ZM7.8 9.9648L11.7 12.1749V16.5864L7.8 14.376V9.9648ZM12.0003 7.2435L15.8922 9.4497L12 11.6553L8.1129 9.4524L12.0003 7.2435ZM11.8518 6.6378L7.3794 9.1788C7.3014 9.2139 7.2384 9.2811 7.2114 9.3669C7.1982 9.4092 7.1946 9.4524 7.2 9.4944V14.5506C7.2 14.6586 7.2582 14.7585 7.3521 14.8116L11.8521 17.3622C11.898 17.3883 11.949 17.4012 12 17.4012C12.051 17.4012 12.102 17.3883 12.1479 17.3622L16.6479 14.8116C16.7418 14.7585 16.8 14.6586 16.8 14.5506V9.4494C16.8 9.3411 16.7418 9.2415 16.6479 9.1884L12.1479 6.6375C12.0558 6.5856 11.9436 6.5859 11.8518 6.6378Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_21507_192393",
    x1: 0,
    y1: 2400,
    x2: 2400,
    y2: 0,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#055F4E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#56C0A7"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWorkspace);
export default __webpack_public_path__ + "static/media/Workspace.073e978e6546a6220d011d39a2ea075b.svg";
export { ForwardRef as ReactComponent };